









































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { showSnackbar } from '@/services/GlobalSnackbarService';
import CreditLimit from '@/models/economy/CreditLimit';
import EconomyService from '../EconomyService';

@Component
export default class DefaultCreditLimit extends Vue {
  creditLimit: CreditLimit | null = null;
  springMenu: boolean = false;
  fallMenu: boolean = false;

  private created() {
    EconomyService.getDefaultCreditLimit().then(response => {
      const data = response.data;
      this.creditLimit = new CreditLimit(data.data)
    }).catch(error => {
      showSnackbar(this.$t('Failed to fetch settings!'), 'error', 5000, null, null)
    })
  }

  private saveSettings() {
    EconomyService.saveDefaultCreditLimit(this.creditLimit.formToModel()).then(response => {
      showSnackbar(this.$t('Successfully saved'), 'success', 5000, null, null)
    }).catch((error) => {
      showSnackbar(this.$t('Failed to save!'), 'error', 5000, null, null)
    })
  }

  private goBack() {
    this.$router.back();
  }

  springDateChange(dates: string[]) {
    if (dates.length === 2 && this.creditLimit) {
      this.creditLimit.creditLimitSpringSeasonStart = dates[0];
      this.creditLimit.creditLimitSpringSeasonEnd = dates[1];
      this.creditLimit.springDateString = `${this.creditLimit.formatDate(dates[0])} - ${this.creditLimit.formatDate(dates[1])}`;
      this.springMenu = false;
    }
  }
  fallDateChange(dates: string[]) {
    if (dates.length === 2 && this.creditLimit) {
      this.creditLimit.creditLimitFallSeasonStart = dates[0];
      this.creditLimit.creditLimitFallSeasonEnd = dates[1];
      this.creditLimit.fallDateString = `${this.creditLimit.formatDate(dates[0])} - ${this.creditLimit.formatDate(dates[1])}`;
      this.fallMenu = false;
    }
  }
  customHeaderText(dates) {
    return `${dates.length} dates selected`
  }

}

